import { NetworkService } from '@sunbit-dev/purchase-common/src/services/networkService/NetworkService';
import { getHigherMaxCreditAmountProps, MxUrlResponse } from '@sunbit-dev/purchase-common/src/components/MxWidgetView/models';
import Offer from '@sunbit-dev/common/models/IOffer';
import OfferRequest from '@sunbit-dev/purchase-common/src/models/OfferRequest';
import { EventsNames } from '@sunbit-dev/purchase-common/src/enums/Events';
import { TrackCategory } from '@sunbit-dev/purchase-common/src/services/networkService/models';
import { GetCustomerVerificationLinkArgs, SendSmsVerificationLinkArgs, GetCustomerVerificationLinkResponse } from './models';

export class ApplyOnlineNetworkService extends NetworkService {
  public async getMxUrl(userId: number) {
    const { origin, pathname } = window.location;
    return this.request<MxUrlResponse>({
      method: 'POST',
      url: `/api/v2/mx/${userId}/widget-url/online`,
      data: {
        clientRedirectUrl: origin + pathname,
        isMobileWebview: false,
      },
      trackingInfo: {
        eventName: EventsNames.mxConnectUrlRequest,
        props: { userId },
        datadogInfo: { type: TrackCategory.Action },
      },
    });
  }

  public async getHigherMaxCreditAmount({ purchaseId, memberId, customer }: getHigherMaxCreditAmountProps) {
    return this.request<Offer>({
      method: 'PUT',
      url: `/api/v2/mx/${purchaseId}/higher-max-credit-amount/online`,
      data: {
        purchase: { customer },
        memberId: memberId,
      },
      trackingInfo: {
        eventName: EventsNames.mxHigherAmountRequest,
        props: { purchaseId, memberId },
        datadogInfo: { type: TrackCategory.Action },
      },
    });
  }

  public async createCheckoutPurchase(ssn?: string) {
    const offerRequest: OfferRequest = {
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };

    if (ssn) {
      offerRequest.customer = {
        ssn,
      };
    }

    return this.request<Offer>({
      method: 'POST',
      url: `/api/v1/epay`,
      data: offerRequest,
    });
  }

  public getCustomerVerificationLink = async ({ upstreamUrl }: GetCustomerVerificationLinkArgs): Promise<GetCustomerVerificationLinkResponse> => {
    return await this.request<GetCustomerVerificationLinkResponse>({
      url: 'api/v2/customer-extra-verification/get-verify-link',
      method: 'post',
      data: { upstreamUrl },
    });
  };

  public sendSmsVerificationLink = async ({ upstreamUrl }: SendSmsVerificationLinkArgs): Promise<void> => {
    return await this.request({
      url: `/api/v2/customer-extra-verification/send-extra-verify-sms/`,
      method: 'post',
      data: { upstreamUrl },
    });
  };
}
